import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);
const NavigationView = () => import('@/pages/NavigationView');
const Index = () => import('@/pages/home/Index');
const Login = () => import('@/pages/Login');
const Store = () => import('@/pages/store/Index');
const Product = () => import('@/pages/product/Index');
const Counter = () => import('@/pages/counter/Index');
const News = () => import('@/pages/news/Index');
const About = () => import('@/pages/about/Index');
const Sale = () => import('@/pages/sale/Index');
const Contract = () => import('@/pages/contract/Index');
const ImageFile = () => import('@/pages/file/Index');
const Watsons = () => import('@/pages/watsons/Index');
const PrintView = () => import('@/pages/watsons/PrintView');

const router = new Router({
    routes: [
        {
            path: '/login',
            name: 'Login',
            component: Login,
        },
        {
            path: '/printView',
            name: 'printView',
            component: PrintView
        },
        {
            path: '/admin',
            name: 'NavigationView',
            component: NavigationView,
            children: [
                {
                    path: 'index',
                    name: 'home',
                    component: Index,
                },
                {
                    path: 'store',
                    name: 'store',
                    component: Store,
                },
                {
                    path: 'product',
                    name: 'product',
                    component: Product,
                },
                {
                    path: 'counter',
                    name: 'counter',
                    component: Counter,
                },
                {
                    path: 'news',
                    name: 'news',
                    component: News,
                },
                {
                    path: 'about',
                    name: 'about',
                    component: About,
                },
                {
                    path: 'sale',
                    name: 'sale',
                    component: Sale,
                },
                {
                    path: 'contract',
                    name: 'contract',
                    component: Contract,
                },
                {
                    path: 'files',
                    name: 'files',
                    component: ImageFile,
                },
                {
                    path: 'watsons',
                    name: 'watsons',
                    component: Watsons
                },
            ],
        },
    ],
});

router.beforeEach(async (to, from, next) => {
    console.log(`from == ${from.path} / ${to.path}`);
    if (to.path === '/'){
        return next('login');
    }
    if (to.path.indexOf('index') > -1 || to.path.indexOf('login') > -1) {
        return next();
    }
    return next();
});

export default router;
